'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _useResize = require('./useResize');

var _useResize2 = _interopRequireDefault(_useResize);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Shiitake = function Shiitake(props) {
  var allChildren = typeof props.children === 'string' ? props.children : '';

  var sizerEl = _react2.default.useRef();
  var spreaderEl = _react2.default.useRef();
  var testChildrenEl = _react2.default.useRef();
  var handlingResize = _react2.default.useRef(true);
  var searchStart = _react2.default.useRef(0);
  var searchEnd = _react2.default.useRef(allChildren.length);

  var className = props.className,
      throttleRate = props.throttleRate,
      overflowNode = props.overflowNode,
      onTruncationChange = props.onTruncationChange;

  var tagNames = { main: (0, _constants.setTag)(props.tagName) };

  var _React$useState = _react2.default.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      testChildren = _React$useState2[0],
      setTestChildren = _React$useState2[1];

  var _React$useState3 = _react2.default.useState(allChildren),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      children = _React$useState4[0],
      setChildren = _React$useState4[1]; // TODO: do we really need render full on server any more???


  var _React$useState5 = _react2.default.useState(-1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      lastCalculatedWidth = _React$useState6[0],
      setLastCalculatedWidth = _React$useState6[1];

  var testChildrenRange = function testChildrenRange(start, end) {
    searchStart.current = start;
    searchEnd.current = end;

    setTestChildren(allChildren.substring(0, end));
  };

  var calculationComplete = function calculationComplete() {
    var newChildren = allChildren;

    // are we actually trimming?
    if (testChildren.length < allChildren.length) {
      newChildren = testChildren.split(' ').slice(0, -1).join(' ');
    }

    handlingResize.current = false;
    setChildren(newChildren);

    // if we  changed the length of the visible string, check if we're switching from truncated to
    // not-truncated or vica versa
    if (newChildren.length !== children.length) {
      var wasTruncatedBefore = children.length !== allChildren.length;
      var isTruncatedNow = newChildren.length !== allChildren.length;

      if (wasTruncatedBefore !== isTruncatedNow && typeof onTruncationChange === 'function') {
        onTruncationChange(isTruncatedNow);
      }
    }
  };

  var checkHeight = function checkHeight() {
    var contentHeight = testChildrenEl.current.offsetHeight;
    var halfWay = Math.round((searchEnd.current - searchStart.current) / 2);
    var targetHeight = sizerEl.current ? sizerEl.current.offsetHeight : undefined;
    var linear = searchEnd.current - searchStart.current < 6;

    // do we need to trim?
    if (contentHeight > targetHeight) {
      // chunk/ trim down
      if (linear) {
        testChildrenRange(testChildren.length, testChildren.length - 1);
      } else {
        testChildrenRange(searchStart.current, searchEnd.current - halfWay);
      }

      // we've used all the characters in a window expand situation
    } else if (testChildren.length === allChildren.length) {
      calculationComplete();
    } else if (linear) {
      // if we just got here by decrementing one, we're good
      if (searchStart.current > searchEnd.current) {
        calculationComplete();
      } else {
        // window grew, increment up one
        testChildrenRange(testChildren.length, testChildren.length + 1);
      }
    } else {
      // chunk up, still in binary search mode
      testChildrenRange(searchEnd.current, searchEnd.current + halfWay);
    }
  };

  var startCalculation = function startCalculation() {
    searchStart.current = 0;
    searchEnd.current = allChildren.length;
    setLastCalculatedWidth(spreaderEl.current.offsetWidth);
    handlingResize.current = true;
    setTestChildren(allChildren);
  };

  var recalculate = function recalculate() {
    // this will kick of a sequence mimicing an initial calculation, this is necessary because if we're currently showing
    // all the children (no need to truncate) then the effect below to check height won't kick in which it needs too.
    setTestChildren('');
  };

  var handleResize = function handleResize() {
    if (!spreaderEl.current) {
      return;
    }

    if (spreaderEl.current.offsetWidth !== lastCalculatedWidth && !handlingResize.current) {
      recalculate();
    }
  };

  (0, _useResize2.default)(handleResize, throttleRate);

  _react2.default.useEffect(function () {
    if (testChildren === '' && sizerEl.current) {
      startCalculation();
    } else {
      checkHeight();
    }
  }, [testChildren, sizerEl.current]);

  _react2.default.useEffect(function () {
    // this will skip this effect on the first render
    if (testChildren !== '') {
      recalculate();
    }
  }, [props.lines]);

  _react2.default.useEffect(function () {
    if (testChildren !== '') {
      recalculate();
    }
  }, [allChildren]);

  var vertSpacers = [];
  for (var i = 0; i < props.lines; i++) {
    vertSpacers.push(_react2.default.createElement(
      'span',
      { style: _constants.block, key: i },
      'W'
    ));
  }

  var maxHeight = (sizerEl.current ? sizerEl.current.offsetHeight : 0) + 'px';
  var overflow = testChildren.length < allChildren.length ? overflowNode : null;

  return _react2.default.createElement(
    tagNames.main,
    _extends({ className: className }, props.attributes),
    _react2.default.createElement(
      'span',
      { style: _extends({}, _constants.wrapperStyles, { maxHeight: maxHeight }) },
      _react2.default.createElement(
        'span',
        { className: 'shiitake-children', style: _constants.childrenStyles },
        children,
        overflow
      ),
      _react2.default.createElement(
        'span',
        { ref: spreaderEl, style: _constants.spreaderStyles, 'aria-hidden': 'true' },
        allChildren
      ),
      _react2.default.createElement(
        'span',
        { style: _constants.sizerWrapperStyles, 'aria-hidden': 'true' },
        _react2.default.createElement(
          'span',
          { ref: sizerEl, style: _constants.block },
          vertSpacers
        ),
        _react2.default.createElement(
          'span',
          { className: 'shiitake-test-children', ref: testChildrenEl, style: _constants.block },
          testChildren,
          overflow
        )
      )
    )
  );
};

Shiitake.propTypes = {
  className: _propTypes2.default.string,
  lines: _propTypes2.default.number.isRequired,
  attributes: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  children: _propTypes2.default.string.isRequired,
  throttleRate: _propTypes2.default.number,
  tagName: _propTypes2.default.string,
  overflowNode: _propTypes2.default.node,
  onTruncationChange: _propTypes2.default.func
};

Shiitake.defaultProps = {
  className: '',
  attributes: {},
  throttleRate: undefined,
  tagName: undefined,
  overflowNode: '\u2026',
  children: '',
  onTruncationChange: undefined
};

exports.default = _react2.default.memo(Shiitake);